module.exports = {"330304001":"景山街道","330304002":"梧田街道","330304003":"南白象街道","330304004":"茶山街道","330304005":"娄桥街道","330304006":"新桥街道","330304007":"三垟街道","330304008":"瞿溪街道","330304009":"郭溪街道","330304010":"潘桥街道","330304011":"丽岙街道","330304012":"仙岩街道","330304108":"泽雅镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330304.json
// module id = 1071
// module chunks = 0